import * as SVG from 'svg.js';

import { FittingSidePosition, Utils } from 'core/utils';
import { DragInfo, HandleBase, Placement, RoughBox } from './handle.base';
import { PositioningHints
       } from '../../collage-designer/stage/placeholder/overlays/action-bar/action-bar.component'; // tslint:disable-line

export class RotationHandle extends HandleBase
{
  private offset: number;
  private position: FittingSidePosition;
  private diameter: number;
  private _actionBarPositioningHints: PositioningHints;

  constructor(element: SVG.Element, handleGroup: SVG.G)
  {
    const mainSVG = (<any>handleGroup).parents(SVG.Doc).pop();
    const stageViewbox = mainSVG.viewbox();
    const factor = stageViewbox.height / mainSVG.rbox().height;
    const diameter = 31 * factor;
    const strokeWidth = 1 * factor;
    const control = handleGroup.nested().style('cursor', 'grab');

    control.width(diameter);
    control.height(diameter);

    control.circle(diameter)
      .fill('white')
      .stroke({ width: strokeWidth })
      .addClass('handle-rotation-control');

    control
      .image('/assets/img/icons/rotate.svg', diameter * 0.7, diameter * 0.7)
      .move(diameter * 0.15, diameter * 0.15);
    super(element, control);

    this.diameter = diameter;
    this.offset = (diameter + strokeWidth);
    this.position = FittingSidePosition.Right;
    this._actionBarPositioningHints = {};
  }

  public get actionBarPositioningHints(): PositioningHints
  {
    return this._actionBarPositioningHints;
  }

  protected updateControl(bounds: RoughBox): void {
    switch (this.position) {
      case FittingSidePosition.Right:
        this.roughCenter(this.control,
                         bounds.x + bounds.width + this.offset,
                         bounds.y + bounds.height / 2,
                         this.diameter,
                         this.diameter);

        this._actionBarPositioningHints = {
          marginRight: 48
        };

        break;
      default: // won't be reached
        throw new Error('not implemented');
    }
  }

  protected drag(info: DragInfo): Placement {
    return {
      rotation: (Utils.rotationToOrigin(info.absolute.x, info.absolute.y)
                 + this.offsetAngle)
    };
  }

  private get offsetAngle(): number {
    switch (this.position) {
      case FittingSidePosition.Top: return 90;
      case FittingSidePosition.Right: return 0;
      case FittingSidePosition.Bottom: return -90;
      case FittingSidePosition.Left: return 180;
      default:
        return 0; // won't be reached
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/controls/transform-handle/handle.rotation.ts